import Textbox from "@acadia-ui/textbox";
import { useEffect, useMemo, useState } from "react";

export default function useSearch({ setSelectedPackage }) {
	const [searchValue, setSearchValue] = useState("");

	const clearSearch = () => {
		setSearchValue("");
		setSelectedPackage(null);
	};

	const searchElement = (
		<Textbox type={"search"} onClear={clearSearch}>
			Search
		</Textbox>
	);

	return useMemo(() => {
		return {
			searchValue,
			searchElement,
			onSearch: (v) => {
				setSearchValue(v);
			}
		};
	}, [searchValue, searchElement, setSearchValue]);
}
